<template>
  <div class="freeboard-ads">
    <div class="freeboard-ads-head">
      <span class="freeboard-ads-heading">
        <i class="ico--ads"></i>
        Advertisement
      </span>

      <button
        class="btn--modify"
        @click="update()"
      >
        <i class="ico--save"></i>
      </button>

      <button
      	class="btn--create"
      	@click="add()"
      >
        <i class="ico--create"></i>
      </button>
    </div>

    <div class="freeboard-ads-media">
    	<ad-items
    		v-for="d in data"
    		:key="d.id"
    		:data="d"
    		@del="deleteData($event)"
    	>
    	</ad-items>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'

//= components
import AdItems from '@/views/boards/AdItems'

//= mixin
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

export default {
  name: 'board-ads',

  components: {
    AdItems
  },

  mixins: [ swal, checkAll ],

  async created () {
    await this.getAdvertisement()
   	this.data = JSON.parse(JSON.stringify(this.ads))
  },

  computed: {
    ...mapState('freeBoard', ['ads'])
  },

  data () {
    return {
      data: [],
      isSaved: false,
      imgPath: process.env.VUE_APP_STATIC_ASSET_PATH
    }
  },

  methods: {
    ...mapActions('freeBoard', [
      'createAdvertisement',
      'getAdvertisement',
      'deleteAdvertisement',
      'updateAdvertisement'
    ]),

    async update () {
      await (new Promise((resolve) => {
        this.$alert('prompt', 'Sure?', {}, () => res(true), 'Save Advertisements')
      }))

    	let edited = []
    	let data = this.data.filter((e) => { return !e.new })
    	let newData = this.data.filter((e) => { return e.new })

    	data = data.map((e) => {
    		e.image = e.image.replace(this.imgPath, '')
    		return e
    	})

      data.forEach((d) => {
        let check = this.ads.find((e) => {
          return e.id === d.id
        })

        if (check.url !== d.url || check.image !== d.image) {
          edited.push(d)
        }
      })

    	if (!edited.length && !newData.length) {
        this.$alert('error', 'There are no changes to be saved.', {}, () => res(true), 'Error')
    		return
    	}

      let formData = new FormData()

      for (var x = 0; x < newData.length; x++) {
        formData.append(`image-${x}`, newData[x].files[0])
        formData.append(`data_url-${x}`, newData[x].url)
      }

      if (newData.length) {
      	await this.createAdvertisement(formData)
      }

      let updateFormData = new FormData()

      for (var x = 0; x < edited.length; x++) {
        if (edited[x].files && edited[x].files.length) {
          updateFormData.append(`image-${x}`, edited[x].files[0])
        }
        updateFormData.append(`data_url`, edited[x].url)
        await this.updateAdvertisement({ id: edited[x].id, params: updateFormData })
      }

      await this.getAdvertisement()

      this.$alert('sucess', 'Changes has been saved.', {}, () => res(true), 'Success')

   		this.data = JSON.parse(JSON.stringify(this.ads))
    },

    add () {
    	this.data.unshift({
    		image: null,
    		url: null,
    		new: true,
        files: null
    	})
    },

    async deleteData (id) {
      await this.deleteAdvertisement(id)
      await this.getAdvertisement(id)
   		this.data = JSON.parse(JSON.stringify(this.ads))
    }
  }
}
</script>
